import styled from "styled-components";

const DrawerBoxWrapper = styled.div`
  background: ${props => props.theme.drawer.box.background};
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  position: relative;
  flex-direction: inherit;
  padding: 1.2rem 1rem;
  margin-bottom: 1rem;
`;

export { DrawerBoxWrapper };
